<div class="custom-table">
  <div id="assets-print-section" class="assets-datatable relative">
    <ngx-datatable
      #assetsTable
      [rows]="data.items"
      [count]="data.totalCount"
      [list]="list"
      [limit]="currentPageSize"
      [selected]="selected"
      [selectionType]="SelectionType.checkbox"
      [selectAllRowsOnPage]="true"
      [trackByProp]="'id'"
      [externalPaging]="true"
      [reorderable]="true"
      [scrollbarH]="true"
      [columnMode]="ColumnMode.force"
      (reorder)="onColumnReorder($event)"
      (page)="onPageChange($event)"
      (select)="onSelectRow($event)"
      default
    >
      <ngx-datatable-column
        [width]="40"
        [sortable]="false"
        [canAutoResize]="false"
        [draggable]="false"
        [resizeable]="false"
        [frozenLeft]="true"
        [style.order]="0"
      >
        <ng-template let-value="value" ngx-datatable-header-template>
          <label class="datatable-checkbox">
            <input
              type="checkbox"
              [checked]="isAllRowsSelected()"
              (change)="selectAllRows($event.target.checked)"
            />
          </label>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <label class="datatable-checkbox pl-2">
            <input
              type="checkbox"
              [checked]="isSelected(row)"
              (change)="onSelectAssets($event, row)"
            />
          </label>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('picture')"
        prop="picture"
        [width]="getColumnWidth('picture') || 105"
        [maxWidth]="105"
        [sortable]="false"
        [style.order]="getColumnOrder('picture')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::Picture' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <a [routerLink]="'/assets/view/' + row.id" class="pr-1 md:!pr-2">
            <div class="flex relative flex-col">
              <img
                class="w-full h-full object-cover rounded"
                [src]="
                  row.pictureUrl
                    ? (service.getPictureUrl(row.id) | authImage | async)
                    : 'assets/images/no-picture.jpg'
                "
              />
            </div>
          </a>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('categoryNickname')"
        prop="categoryNickname"
        [width]="getColumnWidth('categoryNickname') || 120"
        [sortable]="true"
        [style.order]="getColumnOrder('categoryNickname')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::Nickname' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-center w-fit">
            <span class="text-center text-sm">
              {{ row.categoryNickname }}
            </span>
            <i
              *ngIf="row.assetType !== assetType.OWNED"
              class="fa fa-h-square text-xs ml-1"
              [style]="{ color: 'orange' }"
            ></i>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('primaryID')"
        prop="primaryID"
        [width]="getColumnWidth('primaryID') || 110"
        [sortable]="true"
        [style.order]="getColumnOrder('primaryID')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::PrimaryID' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col w-full">
            <a [routerLink]="'/assets/view/' + row.id">
              <span>
                <span>{{ (row.primaryIdPrefix ?? '') + row.primaryID }}</span>
              </span>
            </a>
            <div
              *ngIf="row.parentId || row.isParent"
              class="flex flex-center w-fit !rounded px-[6px] py-[3px]"
              [ngClass]="!row.parentId ? 'bg-green-200' : 'bg-blue-20'"
            >
              <span class="text-center" [ngClass]="!row.parentId ? 'text-green' : 'text-blue-50'">
                {{ row.parentId ? 'Sub' : 'Par' }}
              </span>
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('secondaryID')"
        prop="secondaryID"
        [width]="getColumnWidth('secondaryID') || 110"
        [sortable]="true"
        [style.order]="getColumnOrder('secondaryID')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable"
              >{{ 'RegisterService::SecondaryID' | abpLocalization }}
            </span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col w-full">
            <a [routerLink]="'/assets/view/' + row.id">
              <span class="text-sm">{{ row.secondaryID }}</span>
            </a>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('hours')"
        prop="hours"
        [width]="getColumnWidth('hours') || 100"
        [sortable]="true"
        [style.order]="getColumnOrder('hours')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::CurrentMeters' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span class="text-sm">{{ row.hours }}/{{ row.kilometers }}</span>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('homeLocationName')"
        prop="homeLocationName"
        [width]="getColumnWidth('homeLocationName') || 140"
        [sortable]="true"
        [style.order]="getColumnOrder('homeLocationName')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::HomeLocation' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span class="text-sm">{{ row.homeLocationName }}</span>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('secondaryLocationName')"
        prop="secondaryLocationName"
        [width]="getColumnWidth('secondaryLocationName') || 140"
        [sortable]="true"
        [style.order]="getColumnOrder('secondaryLocationName')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::SecondaryLocation' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span class="text-sm">{{ row.secondaryLocationName || '-' }}</span>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('jobsiteNames')"
        prop="jobsiteNames"
        [width]="getColumnWidth('jobsiteNames') || 140"
        [sortable]="false"
        [style.order]="getColumnOrder('jobsiteNames')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::Jobsites' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div
            class="flex flex-center w-fit !rounded min-w-6 px-[6px] py-[3px]"
            [ngClass]="row.availability === 'AVAILABLE' ? 'bg-blue-20' : 'bg-red-200'"
          >
            <span
              class="text-center text-sm"
              [ngClass]="row.availability === 'AVAILABLE' ? 'text-blue-50' : 'text-red'"
            >
              {{
                row.isDeallocated ? row.deallocationFullName : row.jobsiteNames.join(', ') || '-'
              }}
            </span>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('targetLocationName')"
        prop="targetLocationName"
        [width]="getColumnWidth('targetLocationName') || 140"
        [sortable]="true"
        [style.order]="getColumnOrder('targetLocationName')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::EventLocation' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span class="text-sm">{{ row.targetLocationName || '-' }}</span>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('availability')"
        prop="availability"
        [width]="getColumnWidth('availability') || 110"
        [sortable]="true"
        [style.order]="getColumnOrder('availability')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::Availability' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span
              class="text-sm"
              [ngClass]="row.availability === 'AVAILABLE' ? 'text-green' : 'text-red'"
            >
              {{ 'RegisterService::' + formatAvailability(row.availability) | abpLocalization }}
            </span>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('nextEvent')"
        prop="nextEvent"
        [sortable]="false"
        [width]="getColumnWidth('nextEvent') || 140"
        [style.order]="getColumnOrder('nextEvent')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'QueueService::NextEvent' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <div class="flex justify-between items-center !gap-0.5">
              <button
                type="button"
                class="flex flex-center hover:text-blue-50 text-xs text-gray-60 rounded"
                (click)="onModalOpen('events', row)"
              >
                {{ 'RegisterService::ShowMore' | abpLocalization }}
              </button>
            </div>
            <span class="text-sm"
              >{{ row.nextInspectionOn | date: getShortDateFormat(configState) }} -
              {{ row.inspection?.inspectionTypeName }}</span
            >
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('limits')"
        prop="limits"
        [sortable]="false"
        [width]="getColumnWidth('limits') || 120"
        [style.order]="getColumnOrder('limits')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::DueHrsKm' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span class="text-sm"
              >{{ row.inspection ? row.inspection.hoursLimit : '-' }}{{ row.inspection ? '/' : ''
              }}{{ row.inspection ? row.inspection.kmLimit : '' }}</span
            >
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('compliance')"
        [sortable]="false"
        [style.order]="getColumnOrder('compliance')"
        [width]="getColumnWidth('compliance') || 110"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::ComplianceRisk' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span
              class="text-sm"
              [ngClass]="
                ComplianceStatus[row.complianceStatus] === ComplianceStatus.COMPLIANT
                  ? 'text-green'
                  : ComplianceStatus[row.complianceStatus] === ComplianceStatus.ATRISK
                    ? 'text-red'
                    : ''
              "
            >
              {{ ComplianceStatus[row.complianceStatus] }}</span
            >
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        *ngIf="isColumnVisible('lastSeen')"
        [sortable]="false"
        [width]="getColumnWidth('lastSeen') || 100"
        [style.order]="getColumnOrder('lastSeen')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::LastSeen' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span class="text-sm"> {{ row.lastSeen | date }}</span>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        *ngIf="isColumnVisible('barcode')"
        [sortable]="true"
        [width]="getColumnWidth('barcode') || 120"
        [style.order]="getColumnOrder('barcode')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::Barcode' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <div class="flex !gap-2 items-center">
              <span class="text-sm break-words flex-wrap max-w-[90%]">{{ row.barcode }}</span>
              <i class="bi bi-upc-scan text-gray" *ngIf="row.barcode"></i>
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        *ngIf="isColumnVisible('matched')"
        [sortable]="false"
        [style.order]="getColumnOrder('matched')"
        [width]="getColumnWidth('matched') || 120"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::Matched' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span class="text-sm">
              {{ getFormattedRequestIds(row) }}
            </span>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('rfid')"
        prop="rfid"
        [sortable]="true"
        [width]="getColumnWidth('rfid') || 100"
        [style.order]="getColumnOrder('rfid')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::Rfid' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span class="text-sm">{{ row.rfid }}</span>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('requestNumber')"
        prop="requestNumber"
        [sortable]="true"
        [width]="getColumnWidth('requestNumber') || 120"
        [style.order]="getColumnOrder('requestNumber')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::RequestNumber' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span class="text-sm">{{ row.requestNumber }}</span>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('manufacturerName')"
        prop="manufacturerName"
        [sortable]="true"
        [width]="getColumnWidth('manufacturerName') || 120"
        [style.order]="getColumnOrder('manufacturerName')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::Manufacturer' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span class="text-sm">{{ row.manufacturerName }}</span>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('modelName')"
        prop="modelName"
        [sortable]="true"
        [width]="getColumnWidth('modelName') || 120"
        [style.order]="getColumnOrder('modelName')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::Model' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span class="text-sm">{{ row.modelName || '-' }}</span>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('tracker')"
        prop="tracker"
        [sortable]="true"
        [width]="getColumnWidth('tracker') || 105"
        [style.order]="getColumnOrder('tracker')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::Tracker' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span class="text-sm">{{ row.tracker }}</span>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('secondaryTracker')"
        prop="secondaryTracker"
        [sortable]="true"
        [width]="getColumnWidth('secondaryTracker') || 105"
        [style.order]="getColumnOrder('secondaryTracker')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::SecondaryTracker' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span class="text-sm">{{ row.secondaryTracker }}</span>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('runningCost')"
        prop="runningCost"
        [sortable]="true"
        [width]="getColumnWidth('runningCost') || 120"
        [style.order]="getColumnOrder('runningCost')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::RunningCost' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span class="text-sm">{{ row.runningCost }}</span>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('costCentre')"
        prop="costCentre"
        [sortable]="true"
        [width]="getColumnWidth('costCentre') || 120"
        [style.order]="getColumnOrder('costCentre')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::CostCentre' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-col">
            <span class="text-sm">{{ row.costCentreName }}</span>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('categoryFullName')"
        prop="categoryFullName"
        [sortable]="true"
        [width]="getColumnWidth('categoryFullName') || 120"
        [style.order]="getColumnOrder('categoryFullName')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::Category' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row.categoryName }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('assetType')"
        prop="assetType"
        [sortable]="true"
        [width]="getColumnWidth('assetType') || 100"
        [style.order]="getColumnOrder('assetType')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::AssetType' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span
            class="text-lg"
            [ngClass]="row.assetType === assetType.OWNED ? 'text-green' : 'text-blue-50'"
            >{{ formatAssetType(row.assetType) }}</span
          >
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('status')"
        prop="status"
        [sortable]="true"
        [width]="getColumnWidth('status') || 100"
        [style.order]="getColumnOrder('status')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::Status' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex items-center !gap-2">
            <div
              class="rounded-full w-4 h-4 flex flex-center"
              [ngClass]="
                row.isRecalled
                  ? 'bg-[#FFA50033]'
                  : row.isActive
                    ? 'bg-[#4DC34333]'
                    : 'bg-[#FF495B33]'
              "
            >
              <div
                class="w-[6px] h-[6px] rounded-full"
                [ngClass]="row.isRecalled ? 'bg-orange' : row.isActive ? 'bg-green' : 'bg-red'"
              ></div>
            </div>
            <span
              class="text-sm"
              [ngClass]="row.isRecalled ? 'text-orange' : row.isActive ? 'text-green' : 'text-red'"
              >{{
                row.isRecalled
                  ? ('RegisterService::Recalled' | abpLocalization)
                  : row.isActive
                    ? ('RegisterService::Active' | abpLocalization)
                    : ('RegisterService::InActive' | abpLocalization)
              }}</span
            >
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngIf="isColumnVisible('offhireDate')"
        prop="offhireDate"
        [sortable]="false"
        [width]="getColumnWidth('offhireDate') || 110"
        [style.order]="getColumnOrder('offhireDate')"
      >
        <ng-template ngx-datatable-header-template>
          <div class="d-flex flex-column justify-content-center">
            <span class="datatable-header-cell-label draggable">{{
              'RegisterService::OffhireDate' | abpLocalization
            }}</span>
          </div>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span class="text-xs">{{
            row.assetType === assetType.HIRED ? (todayPlus5Days | date) : '-'
          }}</span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        [width]="120"
        [style.order]="9999"
        [draggable]="false"
        [sortable]="false"
        [frozenRight]="true"
      >
        <ng-template ngx-datatable-header-template>
          <app-assets-columns-dropdown
            [keys]="assetColumns"
            (keysChange)="onAssetColumnsChange($event)"
            [isBusy]="isBusy"
            (isBusyChange)="onIsBusyChange($event)"
            [isCardView]="false"
          ></app-assets-columns-dropdown>
        </ng-template>
        <ng-template let-row="row" let-i="rowIndex" ngx-datatable-cell-template>
          <div class="d-flex justify-content-center align-items-center my-1 w-100">
            <button
              type="button"
              class="!px-4 !py-2 flex flex-center bg-white border border-gray-20 hover:text-black-base text-gray-60 rounded"
              (click)="onView(row)"
            >
              <i class="fa fa-eye me-1 min-w-5" aria-hidden="true"></i>
            </button>
            <div class="btn-group" role="group" container="body" ngbDropdown class="d-inline-block">
              <button
                type="button"
                data-toggle="dropdown"
                class="!px-4 !py-2 flex h-full flex-center bg-white border border-gray-20 hover:text-black-base text-gray-60 rounded"
                aria-haspopup="true"
                ngbDropdownToggle
              >
                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
              </button>
              <div ngbDropdownMenu>
                <button
                  type="button"
                  ngbDropdownItem
                  *abpPermission="'ServicingService.Events.Create'"
                  (click)="onInspect(row)"
                >
                  {{ 'RegisterService::Event' | abpLocalization }}
                </button>
                <button type="button" ngbDropdownItem (click)="onModalOpen('reserve', row)">
                  {{ 'RegisterService::Reserve' | abpLocalization }}
                </button>
                <button
                  *abpPermission="'RegisterService.Assets.Move'"
                  type="button"
                  ngbDropdownItem
                  (click)="onModalOpen('move', row)"
                >
                  {{ 'RegisterService::Move' | abpLocalization }}
                </button>
                <button type="button" ngbDropdownItem (click)="onModalOpen('checkout', row)">
                  {{ 'RegisterService::Checkout' | abpLocalization }}
                </button>
                <button
                  type="button"
                  ngbDropdownItem
                  (click)="onModalOpen('allocate', row)"
                  *ngIf="!row.isDeallocated"
                >
                  {{ 'RegisterService::Allocate' | abpLocalization }}
                </button>
                <button
                  type="button"
                  ngbDropdownItem
                  (click)="onModalOpen('deallocate', row)"
                  [disabled]="row.jobsiteIds.length === 0"
                  *ngIf="row.assetType === assetType.OWNED && !row.isDeallocated"
                >
                  {{ 'RegisterService::Deallocate' | abpLocalization }}
                </button>
                <button
                  type="button"
                  ngbDropdownItem
                  (click)="collectAsset(row)"
                  *ngIf="row.isDeallocated"
                >
                  {{ 'RegisterService::Collect' | abpLocalization }}
                </button>
                <button
                  type="button"
                  ngbDropdownItem
                  (click)="offHireAsset(row)"
                  *ngIf="row.assetType === assetType.HIRED"
                >
                  {{ 'RegisterService::OffHire' | abpLocalization }}
                </button>
                <button
                  *abpPermission="'RegisterService.Assets.ToggleActivity'"
                  type="button"
                  ngbDropdownItem
                  (click)="onModalOpen('status', row)"
                >
                  {{ 'RegisterService::ActiveStatus' | abpLocalization }}
                </button>
                <button
                  type="button"
                  ngbDropdownItem
                  *abpPermission="'RegisterService.Assets.Edit'"
                  (click)="update(row)"
                >
                  {{ 'AbpUi::Edit' | abpLocalization }}
                </button>
                <button
                  *abpPermission="'RegisterService.Requests.Match'"
                  type="button"
                  ngbDropdownItem
                  (click)="onModalOpen('match', row)"
                >
                  {{ 'RegisterService::Match' | abpLocalization }}
                </button>
                <button
                  type="button"
                  ngbDropdownItem
                  *abpPermission="'RegisterService.Assets.Delete'"
                  (click)="delete(row)"
                >
                  {{ 'AbpUi::Delete' | abpLocalization }}
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-footer>
        <ng-template
          ngx-datatable-footer-template
          let-rowCount="rowCount"
          let-pageSize="pageSize"
          let-selectedCount="selectedCount"
          let-curPage="curPage"
          let-offset="offset"
        >
          <div class="page-count d-flex align-items-center gap-2">
            <select
              class="form-select form-select-sm"
              [ngModel]="currentPageSize"
              (ngModelChange)="onPageSizeChange($event)"
              style="width: auto"
            >
              <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
            </select>
            <span> {{ selectedCount.toLocaleString() }} selected / </span>
            {{ data.totalCount.toLocaleString() }} total
          </div>
          <datatable-pager
            [pagerLeftArrowIcon]="'datatable-icon-left'"
            [pagerRightArrowIcon]="'datatable-icon-right'"
            [pagerPreviousIcon]="'datatable-icon-prev'"
            [pagerNextIcon]="'datatable-icon-skip'"
            [page]="curPage"
            [size]="pageSize"
            [count]="data.totalCount"
            [hidden]="!(rowCount / pageSize > 1)"
            (change)="table.onFooterPage($event)"
          >
          </datatable-pager>
        </ng-template>
      </ngx-datatable-footer>
    </ngx-datatable>
  </div>
</div>
<app-queue-modals
  *ngIf="isModalOpen"
  [type]="modalType"
  [asset]="selectedAsset"
  [isModalOpen]="isModalOpen"
  (modalClose)="onModalClose($event)"
></app-queue-modals>

<app-current-events-modal
  *ngIf="openEventsModal"
  [asset]="selectedAsset"
  [openModal]="openEventsModal"
  (modalClose)="openEventsModal = false"
></app-current-events-modal>
